import script from "./no-data-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./no-data-modal.vue?vue&type=script&setup=true&lang=js"

import "./no-data-modal.vue?vue&type=style&index=0&id=439dec16&lang=css"

const __exports__ = script;

export default __exports__